import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { Alert } from "capitalrx-components-2.0";
import "./i18n/i18n";

import AppRoutes from "@/routes";
import { store } from "@/store";
import "./scss/style.scss";

const Root = (): JSX.Element => {
  const { AlertProvider } = Alert;

  return (
    <Provider store={store}>
      <BrowserRouter>
        <AlertProvider>
          <AppRoutes />
        </AlertProvider>
      </BrowserRouter>
    </Provider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);

if (root !== null) {
  root.render(<Root />);
} else {
  throw new Error("Unable to locate app root");
}
